import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AuthShellComponent } from './auth-shell/auth-shell.component';
import { ChangePasswordCardComponent } from './change-password-card/change-password-card.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { PasswordFieldComponent } from './password-field/password-field.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SetNewPasswordComponent } from './set-new-password/set-new-password.component';
import { SignupPageComponent } from './signup/signup-page.component';
import { VerifyEmailPageComponent } from './verify-email/verify-email-page.component';

/** WorldTumbler's own sign-in pages (routes in app-routing.module.ts). */
@NgModule({
  declarations: [
    AuthShellComponent,
    PasswordFieldComponent,
    LoginComponent,
    SignupPageComponent,
    VerifyEmailPageComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    SetNewPasswordComponent,
    ChangePasswordCardComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  exports: [PasswordFieldComponent, ChangePasswordCardComponent],
})
export class AuthPagesModule {}
